module.exports = __webpack_public_path__ + "img/sale-icon.71febf65.svg";